import { AUTH_SERVER, AUTH_ENDPOINTS } from '../servers';
import { postRequest, getRequest } from '../commService';
import { errors as requestErrors } from '../errorHandlingService/errors';

const GENERIC_SIGN_IN_ERROR = 'Sign in failed. Please try again.';

export const getUID = async () =>
  // try {
  //   const result = await postRequest(AUTH_SERVER,
  //     AUTH_ENDPOINTS.GET_UID);
  //   return result.uid;
  // } catch (error) {
  //   throw (new Error(`Token validation error - ${error} `));
  // }
  'SOME_ID';

export const signIn = async (cognitoSub) => {
  try {
    const response = await postRequest(
      AUTH_SERVER,
      AUTH_ENDPOINTS.SIGN_IN,
      { cognitoSub }
    );
    return response.body;
  } catch (error) {
    // commService can throw internal sentinel codes like CONNECTION_ERROR.
    // Never surface these raw values to the end user.
    if (error?.message === requestErrors.CONNECTION_ERROR) {
      throw new Error(requestErrors.CONNECTION_ERROR);
    }

    const statusCode =
      error?.status ||
      error?.statusCode ||
      error?.response?.status ||
      error?.response?.statusCode;

    if (statusCode && statusCode >= 500) {
      throw new Error(requestErrors.CONNECTION_ERROR);
    }

    // Fetch/network failures may not have a status code.
    const message = String(error?.message || '');
    if (/network|timeout|failed to fetch/i.test(message)) {
      throw new Error(requestErrors.CONNECTION_ERROR);
    }

    // Default: generic message (avoid leaking backend/infra details).
    throw new Error(GENERIC_SIGN_IN_ERROR);
  }
};

export const signUp = async (singleDetails) => {
  try {
    const response = await postRequest(AUTH_SERVER, AUTH_ENDPOINTS.SIGN_UP, singleDetails);
    return response.body;
  } catch (error) {
    const errorMessage = error.status >= 500 ? 'Internal server error' : 'Sign Up error';
    throw new Error(`${errorMessage}: ${error.response.body.message}`);
  }
};

export const confirmForgotPassword = async ({ email, code, newPassword }) => {
  try {
    const response = await postRequest(
      AUTH_SERVER,
      AUTH_ENDPOINTS.CONFIRM_FORGOT_PASSWORD,
      { email, code, newPassword },
      'json'
    );
    return response.body;
  } catch (error) {
    // Keep shape consistent with Cognito service wrappers.
    return {
      success: false,
      error: {
        code: error?.response?.body?.code || error?.code || error?.name,
        message: error?.response?.body?.message || error?.message || 'Failed to confirm forgot password',
      },
    };
  }
};

export const postPasswordChangedAtWithToken = async (token) => {
  if (!token) {
    return { success: false, error: { code: 'MISSING_TOKEN', message: 'Missing token' } };
  }

  try {
    await postRequest(
      AUTH_SERVER,
      AUTH_ENDPOINTS.PASSWORD_CHANGED_AT,
      null,
      'json',
      { authTokenOverride: token, retryOn401: false },
    );
    return { success: true };
  } catch (error) {
    return {
      success: false,
      error: {
        code: error?.response?.body?.code || error?.code || error?.name || error?.message,
        message:
          error?.response?.body?.message ||
          error?.message ||
          'Failed to update passwordChangedAt',
      },
    };
  }
};

export const validateUser = async (singleDetails) => {
  try {
    const response = await postRequest(AUTH_SERVER, AUTH_ENDPOINTS.VALIDATE, singleDetails);
    return response.body;
  } catch (error) {
    const errorMessage = error.status >= 500 ? 'Internal server error' : 'Validation error';
    throw new Error(`${errorMessage}: ${error.response.body.message}`);
  }
};

export const getRolesEnum = async () => {
  try {
    const response = await getRequest(
      AUTH_SERVER,
      AUTH_ENDPOINTS.USER_ROLES_ENUM,
    );
    return response.userRolesEnum;
  } catch (error) {
    throw new Error(error.message);
  }
};
